import React, { useEffect, useState } from "react";
import axios from "axios";
import { storage } from "../../firebase.js";
import { ref, uploadBytes } from "firebase/storage";
import { useNavigate, useParams } from "react-router-dom";
import {
  updateDoc,
  doc,
  setDoc,
  getDocs,
  collection,
  query,
  addDoc,
  getDoc,
  deleteDoc,
} from "firebase/firestore";
import { db, auth } from "../../firebase";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Table, Thead, Tbody, Tr, Td } from "react-super-responsive-table";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactDOM from "react-dom";
import Modal from "react-modal";
import { v4 } from "uuid";
import "../app.css";
import { Container } from "react-bootstrap";
import Stack from "@mui/material/Stack";
import Slider from "@mui/material/Slider";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

const marks = [
  {
    value: 1,
    label: "1: Unacceptable",
  },
  {
    value: 2,
    label: "2: Needs Improvement",
  },
  {
    value: 3,
    label: "3: Meets Expectations",
  },
  {
    value: 4,
    label: "4: Exceeds Expectations",
  },
  {
    value: 5,
    label: "5: Outstanding",
  },
];

// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement("#root");
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component={"span"} variant={"body2"}>
            {children}
          </Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function WarningsForm(props) {
  // Criteria Modal Stuff
  let subtitle;
  const [criteriaModalIsOpen, setCriteriaModalIsOpen] = React.useState(false);

  function openCriteriaModal(e) {
    e.preventDefault();
    setCriteriaModalIsOpen(true);
  }

  function afterOpenCriteriaModal() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#f00";
  }

  function closeCriteriaModal() {
    setCriteriaModalIsOpen(false);
  }

  // Other Stuff
  let navigate = useNavigate();

  // Date Stuff
  const convertDate = (secs) => {
    const output = new Date(secs * 1000);
    return output;
  };
  const current = new Date();
  const date = `${
    current.getMonth() + 1
  }/${current.getDate()}/${current.getFullYear()}`;

  const [startDate, setStartDate] = useState(new Date());

  // Tabs Stuff
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    if (!props.newProposal);
    setValue(newValue);
  };

  // Hidden Form Stuff
  const [status, setStatus] = useState("");

  //   Form Stuff
  const [textInput, setTextInput] = useState("");
  const [dateInput, setDateInput] = useState(new Date());
  const [select, setSelect] = useState("Choose One");
  const [warningComments, setWarningComments] = useState([
    {
      description: "",
    },
  ]);
  const [notes, setNotes] = useState([
    {
      description: "",
    },
  ]);
  const [supervisorComments, setSupervisorComments] = useState([
    {
      description: "",
    },
  ]);
  const [newWarningType, setNewWarningType] = useState("");

  //   Form Handling
  const formData = {
    status,
    lastUpdated: date,
    textInput,
    dateInput,
    select,
    warningComments,
  };

  const handleBlur = async (e) => {
    e.preventDefault();
    // if (IDfound === true) {
    //   setDoc(proposalRef, { ...formData, lastUpdated: date }, { merge: true });
    // }
  };

  const handleSelectBlur = async (e) => {
    e.preventDefault();
    // if (IDfound === true) {
    //   setDoc(proposalRef, { ...formData, lastUpdated: date }, { merge: true });
    // }
  };

  const handleBlurWarningComment = async (e, i) => {
    console.log("Calculating New Premium");
    // e.preventDefault();
    const values = [...warningComments];
    values[i].totalPremium = parseFloat(
      (
        values[i].premium +
        values[i].SLtax +
        values[i].companyFee +
        values[i].policyFee +
        values[i].SLstampFee
      ).toFixed(2)
    );
    console.log(formData);
    setWarningComments(values);
    // if (IDfound === true) {
    //   setDoc(proposalRef, { ...formData, lastUpdated: date }, { merge: true });
    // }
  };

  const handleEnter = (event) => {
    if (event.key.toLowerCase() === "enter") {
      const form = event.target.form;
      const index = [...form].indexOf(event.target);
      form.elements[index + 1].focus();
      event.preventDefault();
    }
  };

  const handleChangeInputWarningComment = (i, e) => {
    const values = [...warningComments];
    values[i][e.target.name] = e.target.value;
    setWarningComments(values);
  };

  const handleAddWarningComment = (e) => {
    e.preventDefault();
    const i = warningComments.length;
    if (i > 4) return;
    setWarningComments([
      ...warningComments,
      {
        description: "",
      },
    ]);
  };

  const handleSubtractWarningComment = async (e, i) => {
    e.preventDefault();
    const values = [...warningComments];
    values.splice(i, 1);
    setWarningComments([...values]);
    if (values.length === 0) {
      setWarningComments([
        {
          description: "",
        },
      ]);
    }
    // await updateDoc(proposalRef, { warningComments: values });
  };

  const handleChangeInputNote = (i, e) => {
    const values = [...notes];
    values[i][e.target.name] = e.target.value;
    setNotes(values);
  };

  const handleAddNote = (e) => {
    e.preventDefault();
    const i = notes.length;
    if (i > 4) return;
    setNotes([
      ...notes,
      {
        description: "",
      },
    ]);
  };

  const handleSubtractNote = async (e, i) => {
    e.preventDefault();
    const values = [...notes];
    values.splice(i, 1);
    setNotes([...values]);
    if (values.length === 0) {
      setNotes([
        {
          description: "",
        },
      ]);
    }
    // await updateDoc(proposalRef, { notes: values });
  };

  const handleChangeInputSupervisorComment = (i, e) => {
    const values = [...supervisorComments];
    values[i][e.target.name] = e.target.value;
    setSupervisorComments(values);
  };

  const handleAddSupervisorComment = (e) => {
    e.preventDefault();
    const i = supervisorComments.length;
    if (i > 4) return;
    setSupervisorComments([
      ...supervisorComments,
      {
        description: "",
      },
    ]);
  };

  const handleSubtractSupervisorComment = async (e, i) => {
    e.preventDefault();
    const values = [...supervisorComments];
    values.splice(i, 1);
    setSupervisorComments([...values]);
    if (values.length === 0) {
      setSupervisorComments([
        {
          description: "",
        },
      ]);
    }
    // await updateDoc(proposalRef, { supervisorComments: values });
  };

  // Show or Hide
  const [showWarningsForm, setShowWarningsForm] = useState(false);

  //   Clear the form
  const clearForm = () => {
    setNewWarningType("");
    setWarningComments([{ description: "" }]);
    setNotes([{ description: "" }]);
    setSupervisorComments([{ description: "" }]);
  };

  //   Submit the warnings & close the form
  const [warningsSubmitted, setWarningsSubmitted] = useState(false);
  const submitWarnings = async (e) => {
    e.preventDefault();
    const docRef = await addDoc(collection(db, "hr-warnings"), {
      hideOnList: true,
      status: "",
      createdOn: new Date(),
      createdBy: auth.currentUser.uid,
      author: auth.currentUser.displayName,
      warningDate,
      newWarningType,
      employeeID: props.selectedUserID,
      otherTypeDetails,
      incidentDescription,
      employeeExplanation,
      warningLocation,
      planForImprovement,
      furtherConsequences,
      supervisorStatement,
      replies: [],
    });
    console.log("Document written with ID: ", docRef.id);
    clearForm();
    setShowWarningsForm(false);
    setWarningsSubmitted(true);
    props.setHRwarnings([]);
    props.setGotWarnings(false);
    props.setWarningsUpdated(props.warningsUpdated + 1);
  };

  const [warningLocation, setWarningLocation] = useState("");
  const [warningDate, setWarningDate] = useState();
  const [satisfactionValue, setSatisfactionValue] = React.useState(0);
  const handleChangeSatisfaction = (event, newValue) => {
    setSatisfactionValue(newValue);
  };
  const [otherTypeDetails, setOtherTypeDetails] = useState("");
  const [incidentDescription, setIncidentDescription] = useState("");
  const [employeeExplanation, setEmployeeExplanation] = useState("");
  const [planForImprovement, setPlanForImprovement] = useState("");
  const [furtherConsequences, setFurtherConsequences] = useState("");
  const [supervisorStatement, setSupervisorStatement] = useState("");
  useEffect(() => {}, [showWarningsForm, warningsSubmitted]);

  return (
    <div className="card">
      <div className="card-header">
        <button
          onClick={(e) => {
            setShowWarningsForm(!showWarningsForm);
            setWarningsSubmitted(false);
          }}
          className="text-lg font-bold text-sky-600"
        >
          Add Warning
        </button>
        {warningsSubmitted && (
          <p className="p-2 w-full bg-green-200 float-right font-bold mb-2">
            Your warning was successfully submitted.
          </p>
        )}
      </div>
      {showWarningsForm && (
        <div className="card-body">
          <form onSubmit={(e) => submitWarnings(e)}>
          {/* Warning Title */}
          <section className="card bg-gray-100 m-3">
            <div className="card-header w-full">
              <h2 className="font-bold text-2xl text-red-900">
                Type of Violation
              </h2>
            </div>
            <div className="card-body">
              <div>
                <select
                  required
                  onChange={(e) => setNewWarningType(e.target.value)}
                  onBlur={(e) => handleBlur(e)}
                  onKeyDown={handleEnter}
                  name="description"
                  className="form-control rounded"
                  type="text"
                  placeholder="Warning Type"
                  value={newWarningType}
                >
                  <option value="Choose One"></option>
                  <option value="Assistance">Assistance</option>
                  <option value="Distraction">Distraction</option>
                  <option value="Disobedience">Disobedience</option>
                  <option value="Security">Security</option>
                  <option value="Tardy">Tardy</option>
                  <option value="Quality of Work">Quality of Work</option>
                  <option value="Other">Other</option>
                </select>
                {newWarningType === "Other" && (
                  <>
                    <label className="mt-1">Please Explain:</label>
                    <input
                      required
                      className="form-control rounded"
                      type="text"
                      value={otherTypeDetails}
                      onClick={(e) => setOtherTypeDetails(e.target.value)}
                    />
                  </>
                )}
              </div>
            </div>
          </section>
          {/* Warning Location */}
          <section className="card bg-gray-100 m-3">
            <div className="card-header w-full">
              <h2 className="font-bold text-2xl text-red-900">
                Incident Location
              </h2>
            </div>
            <div className="card-body">
              <div>
                <input
                  required
                  onChange={(e) => setWarningLocation(e.target.value)}
                  onBlur={(e) => handleBlur(e)}
                  onKeyDown={handleEnter}
                  name="description"
                  className="form-control rounded"
                  type="text"
                  placeholder="Incident Location"
                  value={warningLocation}
                />
              </div>
            </div>
          </section>
          {/* Warning Date */}
          <section className="card bg-gray-100 m-3">
            <div className="card-header w-full">
              <h2 className="font-bold text-2xl text-red-900">Incident Date</h2>
            </div>
            <div className="card-body pl-10">
              <DatePicker
                selected={warningDate}
                onChange={(date: Date) => {
                  setWarningDate(date);
                }}
                className={`text-input`}
              />
            </div>
          </section>
          {/* Description */}
          <section className="card bg-gray-100 m-3">
            <div className="card-header w-full">
              <h2 className="font-bold text-2xl text-red-900">
                Description of Incident
              </h2>
            </div>
            <div className="card-body">
              <div>
                <textarea required
                  onChange={(e) => setIncidentDescription(e.target.value)}
                  onBlur={(e) => handleBlur(e)}
                  onKeyDown={handleEnter}
                  name="description"
                  className="form-control rounded"
                  type="text"
                  placeholder="Incident Description"
                  value={incidentDescription}
                />
              </div>
            </div>
          </section>
          {/* Employee Explanation */}
          <section className="card bg-gray-100 m-3">
            <div className="card-header w-full">
              <h2 className="font-bold text-2xl text-red-900">
                Employee Explanation
              </h2>
            </div>
            <div className="card-body">
              <div>
                <textarea required
                  onChange={(e) => setEmployeeExplanation(e.target.value)}
                  onBlur={(e) => handleBlur(e)}
                  onKeyDown={handleEnter}
                  name="explanation"
                  className="form-control rounded"
                  type="text"
                  placeholder="Did the employee offer an explanation? If so, enter the details here."
                  value={employeeExplanation}
                />
              </div>
            </div>
          </section>
          {/* Plan For Improvement */}
          <section className="card bg-gray-100 m-3">
            <div className="card-header w-full">
              <h2 className="font-bold text-2xl text-red-900">
                Plan For Improvement
              </h2>
            </div>
            <div className="card-body">
              <div>
                <input
                  required
                  onChange={(e) => setPlanForImprovement(e.target.value)}
                  onBlur={(e) => handleBlur(e)}
                  onKeyDown={handleEnter}
                  name="plan"
                  className="form-control rounded"
                  type="text"
                  placeholder="Describe the plan you and the employee came up with to improve"
                  value={planForImprovement}
                />
              </div>
            </div>
          </section>
          {/* Consequences of Further Actions */}
          <section className="card bg-gray-100 m-3">
            <div className="card-header w-full">
              <h2 className="font-bold text-2xl text-red-900">
                Consequences of Further Actions
              </h2>
            </div>
            <div className="card-body">
              <div>
                <input
                  required
                  onChange={(e) => setFurtherConsequences(e.target.value)}
                  onBlur={(e) => handleBlur(e)}
                  onKeyDown={handleEnter}
                  name="consequences"
                  className="form-control rounded"
                  type="text"
                  placeholder="Consequences of Further Actions"
                  value={furtherConsequences}
                />
              </div>
            </div>
          </section>
          {/* Supervisor Statement */}
          <section className="card bg-gray-100 m-3">
            <div className="card-header w-full">
              <h2 className="font-bold text-2xl text-red-900">
                Supervisor Statement
              </h2>
            </div>
            <div className="card-body">
              <div>
                <input
                  required
                  onChange={(e) => setSupervisorStatement(e.target.value)}
                  onBlur={(e) => handleBlur(e)}
                  onKeyDown={handleEnter}
                  name="supervisorStatement"
                  className="form-control rounded"
                  type="text"
                  placeholder="Enter your statement here"
                  value={supervisorStatement}
                />
              </div>
            </div>
          </section>
          <button
          type="submit"
            
            className="block font-medium text-white my-1 p-2 rounded bg-green-900 hover:bg-green-700"
          >
            Submit Warning
          </button>
          <p className="text-xs">
            You may not edit a warning once it is submitted.
          </p>
        </form>
        </div>
      )}
    </div>
  );
}

export default WarningsForm;
